module.exports = __webpack_public_path__ + "img/x.b9cf79be.svg";